import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import styles from "./DecisionWorkspaceVisual.module.css";
import { Button } from "@/components/ax/Button";
import { StatusTag } from "@/pages/Keputusan";
import { useI18n } from "@/i18n";
import { ChooseByControl } from "./ChooseByControl";

export const Masthead = ({ w }) => {
  const { t } = useI18n();
  const d = w.decision;
  return (
    <header data-testid="workspace-masthead">
      <Link
        to="/keputusan"
        data-testid="workspace-all-link"
        className="inline-flex min-h-[48px] items-center text-sm font-medium text-ax-link hover:underline"
      >
        <ArrowLeft size={16} strokeWidth={1.5} aria-hidden="true" />
        {t("workspace.back")}
      </Link>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <span className="font-mono text-[13px] leading-[18px] text-ax-muted">{t("horizon.days", { n: d.horizonDays })}</span>
        <StatusTag status={d.status} />
        {d.brief && <span className={styles.briefTag} data-testid="workspace-brief-tag">{t("workspace.briefVersion", { n: d.brief.version })}</span>}
      </div>
      <h1 className="type-h1 mt-3 [overflow-wrap:anywhere]" data-testid="workspace-title">
        {d.title}
      </h1>
      <p className="m-0 mt-2 text-base leading-6 text-ax-text-2 [overflow-wrap:anywhere]" data-testid="workspace-question">
        {d.question}
      </p>
      {d.desiredOutcome && (
        <div className="mt-3">
          <p className="caption m-0 text-ax-muted">{t("field.outcome")}</p>
          <p className="m-0 mt-1 text-base leading-6 text-ax-text [overflow-wrap:anywhere]">{d.desiredOutcome}</p>
        </div>
      )}
      <div className="mt-3 flex flex-wrap items-center justify-between gap-x-4">
        {w.aiOn ? (
          <span data-testid="workspace-quota" className="font-mono text-[13px] leading-[18px] text-ax-muted">
            {t("ai.quota", { n: w.left })}
          </span>
        ) : (
          <span />
        )}
        <Button
          variant="ghost"
          onClick={w.togglePin}
          disabled={w.busy === "pin"}
          aria-pressed={d.attentionPinned}
          data-testid="workspace-pin-button"
          className="px-0"
        >
          {d.attentionPinned ? t("ws.unpin") : t("ws.pin")}
        </Button>
      </div>
      <ChooseByControl decision={d} onSave={w.setChooseBy} disabled={!!w.busy} />
      {w.errors.pin && (
        <p role="alert" data-testid="workspace-pin-error" className="m-0 text-sm leading-5 text-ax-error">
          {w.errors.pin}
        </p>
      )}
    </header>
  );
};
